import {APPLICATION_DATA_SOURCE_REGISTRY} from '../service/applicationDataSource.registry';
import {APP_CONFIG_STATES} from './appConfig.states';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.core.application.config.dataSource', [
    APPLICATION_DATA_SOURCE_REGISTRY,
    APP_CONFIG_STATES,
  ])
  .run(function($q, applicationDataSourceRegistry) {
    applicationDataSourceRegistry.registerDataSource({
      key: 'config',
      label: 'Config',
      sref: '.config',
      active: '**.config.**',
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/application/config/appConfig.dataSource.js